package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.model.GameEvent
import fr.manyverse.app.domain.repository.GameEventRepository

class NotifyPlayerJoinedUseCase(
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        triggeredBy: String,
        characterName: String
    ): Result<GameEvent> = gameEventRepository.createEvent(
        tableId = tableId,
        type = EventType.PLAYER_JOINED,
        triggeredBy = triggeredBy,
        targetParticipants = emptyList(),
        content = EventContent.PlayerJoined(characterName = characterName)
    )
}
